import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import useDetectPrint from 'react-detect-print';

import Adhesion from '../../../atoms/adhesion';
import CardResource from '../../../molecules/profile/card-resource';
import CardResourceContainer from '../../../molecules/profile/card-resource-container';
import FeesAndExpenses from '../../../molecules/profile/fees-and-expenses';
import FooterDisclosures from '../../../atoms/footer-disclosures';
import HeaderQuoteBar from '../../../molecules/profile/header-quote-bar';
import PageHeader from '../../../molecules/profile/page-header';
import PageMain from '../../../molecules/profile/page-main';
import PageSideRail, { DisclosurePrint } from '../../../molecules/profile/page-side-rail';
import PerformanceReturns from '../../../molecules/profile/performance-returns';
import RisksDisclosure from '../../../molecules/profile/risks-disclosure';
import SectionDivider from '../../../atoms/section-divider';
import sectionDividerOptions from '../../../../helpers/statics/section-divider-options';
import useStore from '../../../../stores/profile/use-other-money-market-store';
import { className } from '../../../../utils/GlobalCssProxy';
import { getIsDynamicGreetingShown } from '../../../molecules/profile/dynamic-greeting/dynamic-greeting-helper';

const OtherMoneyMarket = () => {
  const store = useStore();
  const quoteData = store.quote.isLoaded ? store.quote.data : {};
  const participantHoldingsData =
    store.participantHoldings && store.participantHoldings.isLoaded
      ? store.participantHoldings.data
      : {};

  const showDynamicGreeting =
    participantHoldingsData && getIsDynamicGreetingShown(participantHoldingsData);
  const disclosureList = store.disclosureList.isLoaded ? store.disclosureList.data : [];
  const printing = useDetectPrint();
  // const printingFeesExpenses = [disclosureList.find(item => { return item?.component === 'performance-returns'; })];

  return (
    <div data-template="OtherMoneyMarket">
      <PageHeader
        displayAsFundType="Other Investments"
        sectionNavOptions={[sectionDividerOptions.performance, sectionDividerOptions.resources]}
      >
        <HeaderQuoteBar>
          <HeaderQuoteBar.GrossNetExpenseRatio
            grossValue={quoteData.grossExpenseRatio}
            netValue={quoteData.netExpenseRatio}
          />
          <HeaderQuoteBar.SevenDayYield
            value={quoteData['7DayYieldCurrent']}
            asOfDate={quoteData['7DayYieldAsOfDate']}
          />
          <HeaderQuoteBar.AccountInceptionDate
            asOfDate={quoteData.inceptionDate}
            isOther
            responsive={printing ? undefined : 1}
          />
        </HeaderQuoteBar>
      </PageHeader>
      <PageMain>
        <SectionDivider
          labelText={sectionDividerOptions.performance.label}
          id={sectionDividerOptions.performance.id}
          isDynamicGreetingShown={showDynamicGreeting}
          dynamicGreetingParticipantHoldings={participantHoldingsData}
        >
          <Row>
            <Col>
              <PerformanceReturns {...store.performanceReturns} />
            </Col>
          </Row>
          <Row>
            <Col>
              <FeesAndExpenses
                expenses={store.feesExpenses.isLoaded ? store.feesExpenses.data : {}}
                heading="Fees &amp; Expenses"
              />
            </Col>
            <Col md={8} {...className('d-none', 'd-md-block')}>
              <Adhesion.Performance />
            </Col>
          </Row>
          <Row>
            <Col>
              <RisksDisclosure />
            </Col>
          </Row>
        </SectionDivider>
        <SectionDivider
          labelText={sectionDividerOptions.resources.label}
          id={sectionDividerOptions.resources.id}
        >
          <CardResourceContainer>
            <CardResource.SimpleLink
              bodyText="Retirement Planner"
              href="https://shared.tiaa.org/private/digitalinvestadvice/experience/personalgoals/userlanding"
              data-analytics-componenttype="column-component"
              data-analytics-id="COL_Learn"
              data-analytics-section="component"
              iconVariant="Learn"
              titleText="Learn"
            />
            <CardResource.SimpleLink
              bodyText="Retirement Calculators & Tools"
              data-analytics-componenttype="column-component"
              data-analytics-id="COL_Tools"
              data-analytics-section="component"
              href="https://www.tiaa.org/public/offer/insights/tools-calculators"
              iconVariant="Calculator"
              titleText="Tools"
            />
          </CardResourceContainer>
        </SectionDivider>
        <FooterDisclosures />
        <div {...className('admaster-number', 'd-print-none')}>X-3240794P-Q0923W</div>
        <DisclosurePrint disclosureList={disclosureList} admasterNumber="X-3240794P-Q0923W" />
      </PageMain>
      <PageSideRail />
    </div>
  );
};

export default OtherMoneyMarket;
